/**
 * VWO Adapter
 * 
 * Adapts event data into VWO (Visual Website Optimizer) format.
 * VWO is primarily used for A/B testing and experimentation tracking.
 * 
 * @since 1.51.0
 */

(function (pmw, $, undefined) {

	class VWOAdapter {
		
		/**
		 * Adapt event data to VWO format
		 * 
		 * @param {object} eventData - Event-specific data (product, order, etc.)
		 * @param {string} eventName - Standardized event name
		 * @param {object} context - Event context (user, page, etc.)
		 * @returns {object|null} Adapted data for VWO or null if pixel not loaded
		 */
		adapt(eventData, eventName, context) {
			
			// Check if VWO pixel is loaded
			if (!pmwDataLayer?.pixels?.vwo?.loaded) {
				return null;
			}
			
			const eventMap = {
				'purchase': () => this.adaptRevenueConversion(eventData),
			};
			
			if (!eventMap[eventName]) {
				return null;
			}
			
			return eventMap[eventName]();
		}
		
		/**
		 * Adapt purchase event to revenue conversion
		 */
		adaptRevenueConversion(eventData) {
			return {
				event_type: 'track.revenueConversion',
				revenue_value: pmwDataLayer.order.value.total,
			};
		}
	}
	
	// Register the adapter
	pmw.registerAdapter('vwo', new VWOAdapter(), {
		supportsS2S: false,
		supportsEventDeduplication: false,
		isActive: () => pmwDataLayer?.pixels?.vwo?.account_id ? true : false
	});
	
}(window.pmw = window.pmw || {}, jQuery));
